import { User } from 'src/models/user';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheUserDetailsOfTheAuthenticatedUserQueryCallBack extends Callback<User> {
	public constructor(private readonly setAuthenticatedUserInformation: (user: User | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: User): void => {
		this.setAuthenticatedUserInformation(successResponse);
	};
}
